import {
  SearchSortType,
  SortingDirection,
} from 'graphql-api/gql-api-interfaces';

export interface Facet {
  fieldId: string;
  fieldDisplayName: string;
  translationKey?: string;
  isRange: number;
  fieldType: number;
  facetValues?: FacetValue[];
  properties: Record<string, unknown>;
}

export interface FacetValue {
  displayValue: string;
  value: string | number | boolean;
  count?: number;
  subFacets?: Facet[];
}

export enum FacetFilterId {
  Brand = 'brand',
  BrandName = 'brandname',
  SubBrand = 'subbrandname',
  Category = 'categoryname',
}

export type FilterQueryParams = {
  q: string | null;
  f: string | null;
  subsites: string | null;
  availability: string;
  maxAge: string;
  rrp: string;
  wsp: string;
  sortField: SearchSortType;
  sortDirection: SortingDirection;
  orderedProductsBrandId?: string;
  preset?: string;
  orderHistoryFromDate?: string;
  orderHistoryToDate?: string;
  collapse?: boolean;
  inventoryRange?: string;
  isdDates?: string;
  filterOutInbound?: string;
  filterOutRecentlyDelivered?: string;
  withRelatedVariants?: boolean;
  useV2Search?: boolean;
  useCatalogOnlyMode?: boolean;
};
